import { arrayBufferToHexString } from './array-buffer-to-hex-string';

export function readAndConvertToHex(
	file: File,
	onSuccess: (value: string) => Promise<void>,
	onFail: (error: unknown) => void,
) {
	const reader = new FileReader();

	reader.onload = (loadEvent: FileReaderLoadEvent) => {
		const arrayBuffer = loadEvent.target.result;
		if (arrayBuffer instanceof ArrayBuffer) {
			const hexString = arrayBufferToHexString(arrayBuffer);
			onSuccess(hexString).catch(onFail);
		} else {
			onFail('Error: Failed to read file as ArrayBuffer.');
		}
	};

	reader.onerror = onFail;

	// Read the file content as a binary ArrayBuffer.
	reader.readAsArrayBuffer(file);
}
